import { Button } from '@applyboard/crystal-ui'
import { ApplicationResource } from '@applyboard/school-applications-types-lib'
import { useEffect } from 'react'
import { useGetApplication, useGetSchool } from '../../hooks'
import styled from '@emotion/styled'
import { useFlywireAction } from '../../hooks/applications/useFlywireAction'

declare global {
  interface Window {
    flywire: {
      Checkout: {
        render: (config: unknown, html: unknown) => void
      }
    }
  }
}

export type FlywireButtonProps = {
  application: ApplicationResource
  onClick: () => void
}

export function FlywireButton(props: FlywireButtonProps): JSX.Element {

  const { isLoadingApplication } = useGetApplication({ id: props.application.id })
  const { school, isLoadingSchool } = useGetSchool()
  const { hiddenButtonRef, handleOnClick, setFlywireDialogTrigger } = useFlywireAction({
    applicationId: props.application.id,
    onSuccess: props.onClick,
  })

  useEffect(() => {
    setFlywireDialogTrigger(props.application, school)
  }, [props.application, school])

  const isLoading = isLoadingApplication || isLoadingSchool

  return (
    <>
      <Button width="fill" intent="primary" loading={isLoading} onClick={handleOnClick}>
        Yes, continue to pay
      </Button>
      <HiddenButton ref={hiddenButtonRef} id="checkout-button" />
    </>
  )
}

const HiddenButton = styled.button({
  display: 'none',
})
